import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import useAccessToken from "../auth/useAccessToken";
import FormDropdown from "./FormDropdown";
import { FormSearchDropdownOption } from "./FormSearchDropdown/FormSearchDropdown";
import { fetchWheelPositionOptions } from "../api/wheelPositions";

export type WheelPositionDropdownProps = {
    value: string
    onChange: (value: string, option: FormSearchDropdownOption | null) => void
    disabled?: boolean
    required?: boolean
    error?: FieldError
    tooltip?: string
    label: string
}

export const WheelPositionDropdown = ({
    value,
    onChange,
    disabled,
    required,
    error,
    tooltip,
    label
}: WheelPositionDropdownProps) => {
    const accessToken = useAccessToken();
    const [allOptions, setAllOptions] = useState<FormSearchDropdownOption[]>([]);

    const fetchDropdownOptions = async () => {
        const response = await fetchWheelPositionOptions(accessToken);

        return response
            .map(option => ({
                value: option.value,
                label: option.label,
            }));
    };

    useEffect(() => {
        if (!accessToken) return;

        const loadAllOptions = async () => {
            const fetchedOptions = await fetchDropdownOptions();
            setAllOptions(fetchedOptions);
        };

        loadAllOptions();
    }, [accessToken]);

    return (
        <FormDropdown
            required={required}
            label={label}
            tooltip={tooltip}
            options={allOptions}
            error={error}
            value={value}
            onChange={onChange}
            disabled={disabled}
            isLoadingOptions={allOptions.length < 1}
        />
    );
};

export default WheelPositionDropdown;